import React, { Component } from "react";
import { defaultFilter } from "../constants";
import {
  loyaltyLevelOptions,
  memberLevelOptions,
  operatorOptions,
  prospekCategoryOptions,
  prospekSourceOptions,
  prospekTypeOptions,
  socMedOptions,
} from "../constants";
import SimpleModal from "../../../../../modules/popup/SimpleModal";
import ModalContainer from "../../../../../modules/commons/ModalContainer";
import FlexView from "react-flexview";
import SimpleDDL from "../../../../../modules/SimpleDDL";
import SimpleInput from "../../../../../modules/SimpleInput";
import DateRange from "../../../payment/common/dateRange";
import moment from "moment";
import SimpleButton from "../../../../../modules/commons/SimpleButton";
import { fetchDataAsync } from "../../../../../Services/Utils";
import Api from "../../../../../Services/Api";
import * as R from "ramda";
import { mapToObjectDDL } from "../../../../common/mapper";

export default class CrmFollowUpH23Filter extends Component {
  constructor(props) {
    super(props);
    this.state = {
      filter: defaultFilter,
      prospekCategoryOptions: prospekCategoryOptions,
      prospekTypeOptions: prospekTypeOptions,
      prospekSourceOptions: prospekSourceOptions,
      operatorOptions: operatorOptions,
      provinceOptions: [],
      kabkotOptions: [],
      kecamatanOptions: [],
      kelurahanOptions: [],
      zipCodeOptions: [],
      levelOptions: memberLevelOptions,
      loyaltyOptions: loyaltyLevelOptions,
      hobbyOptions: [],
      interestOptions: [],
      socMedOptions: socMedOptions,
      zipCodeRaw: [],
    };
  }

  componentDidMount() {
    const { search } = this.props;
    if (!R.isEmpty(search)) {
      this.setState((prevValue) => ({
        ...prevValue,
        filter: {
          ...defaultFilter,
          ...(search || {}),
        },
      }));
    }
    this.fetchDataProvince();
    this.fetchDataHobby();
    this.fetchDataInterest();
  }

  componentDidUpdate = async (prevProps, prevState, snapshot) => {
    const prevFilter = prevState.filter;
    const currFilter = this.state.filter;
    const { zipCodeRaw } = this.state;
    if (prevFilter?.province?.value !== currFilter?.province?.value) {
      this.setState((prevValue) => ({
        ...prevValue,
        filter: {
          ...prevValue.filter,
          kabkot: prevFilter?.province?.value ? {} : prevValue.filter.kabkot,
          kecamatan: prevFilter?.province?.value
            ? {}
            : prevValue.filter.kecamatan,
          kelurahan: prevFilter?.province?.value
            ? {}
            : prevValue.filter.kelurahan,
          kodePos: prevFilter?.province?.value ? {} : prevValue.filter.kodePos,
        },
        kecamatanOptions: [],
        kelurahanOptions: [],
        zipCodeOptions: [],
      }));
      if (!R.isNil(currFilter?.province))
        await this.fetchDataKabKot(currFilter.province.value);
    }
    if (prevFilter?.kabkot?.value !== currFilter?.kabkot?.value) {
      this.setState((prevValue) => ({
        ...prevValue,
        filter: {
          ...prevValue.filter,
          kecamatan: prevFilter?.province?.value
            ? {}
            : prevValue.filter.kecamatan,
          kelurahan: prevFilter?.province?.value
            ? {}
            : prevValue.filter.kelurahan,
          kodePos: prevFilter?.province?.value ? {} : prevValue.filter.kodePos,
        },
        kelurahanOptions: [],
        zipCodeOptions: [],
      }));
      if (!R.isNil(currFilter?.kabkot))
        await this.fetchDataKecamatan(currFilter.kabkot.value);
    }
    if (prevFilter?.kecamatan?.value !== currFilter?.kecamatan?.value) {
      this.setState((prevValue) => ({
        ...prevValue,
        filter: {
          ...prevValue.filter,
          kelurahan: prevFilter?.province?.value
            ? {}
            : prevValue.filter.kelurahan,
          kodePos: prevFilter?.province?.value ? {} : prevValue.filter.kodePos,
        },
        zipCodeOptions: [],
      }));
      if (!R.isNil(currFilter?.kecamatan))
        await this.fetchDataKelurahan(currFilter.kecamatan.value);
    }
    if (
      prevFilter?.kelurahan?.value !== currFilter?.kelurahan?.value &&
      !R.isEmpty(zipCodeRaw)
    ) {
      const data = R.isNil(currFilter?.kelurahan)
        ? []
        : zipCodeRaw.find((item) => item.id === currFilter.kelurahan.value);
      this.setState((prevValue) => ({
        ...prevValue,
        filter: {
          ...prevValue.filter,
          kodePos: prevFilter?.province?.value ? {} : prevValue.filter.kodePos,
        },
        zipCodeOptions: !R.isEmpty(data)
          ? [mapToObjectDDL(data?.zipcode, data?.zipcode)]
          : [],
      }));
    }
  };

  fetchDataHobby = async () => {
    try {
      const response = await fetchDataAsync({
        asyncFn: Api.create("NAGAMAS_MASTER_DATA").getAllBizparByParam,
        setError: this.props.setError,
        menuName: "",
        args: { paramFilters: { bizparCategory: "HOBBY_TYPE" } },
      });
      if (response.ok && !R.isEmpty(response.data.data)) {
        this.setState((prevValue) => ({
          ...prevValue,
          hobbyOptions: response.data.data.map((item) =>
            mapToObjectDDL(item.value, item.key)
          ),
        }));
      }
    } catch (e) {
      console.log("errors", e);
    }
  };

  fetchDataInterest = async () => {
    try {
      const response = await fetchDataAsync({
        asyncFn: Api.create("NAGAMAS_MASTER_DATA").getAllBizparByParam,
        setError: this.props.setError,
        menuName: "",
        args: { paramFilters: { bizparCategory: "INTEREST_TYPE" } },
      });
      if (response.ok && !R.isEmpty(response.data.data)) {
        this.setState((prevValue) => ({
          ...prevValue,
          interestOptions: response.data.data.map((item) =>
            mapToObjectDDL(item.value, item.key)
          ),
        }));
      }
    } catch (e) {
      console.log("errors", e);
    }
  };

  fetchDataProvince = async () => {
    try {
      const response = await Api.create("NAGAMAS_MASTER_DATA").getAllProvince();
      if (response.ok && !R.isEmpty(response.data.data)) {
        this.setState((prevValue) => ({
          ...prevValue,
          provinceOptions: response.data.data.map((item) =>
            mapToObjectDDL(item.provinceName, item.id)
          ),
        }));
      }
    } catch (e) {
      console.log("errors", e);
    }
  };

  fetchDataKabKot = async (id) => {
    try {
      const response = await Api.create("NAGAMAS_MASTER_DATA").getAllCity(id);
      if (response.ok && response.data.data) {
        this.setState((prevValue) => ({
          ...prevValue,
          kabkotOptions: response.data.data?.map((item) =>
            mapToObjectDDL(item.kabKotName, item.kabKotId)
          ),
        }));
      }
    } catch (e) {
      console.log("errors", e);
    }
  };

  fetchDataKecamatan = async (id) => {
    try {
      const response = await Api.create("NAGAMAS_MASTER_DATA").getAllKecamatan(
        id
      );
      if (response.ok && response.data.data) {
        this.setState((prevValue) => ({
          ...prevValue,
          kecamatanOptions: response.data.data?.map((item) =>
            mapToObjectDDL(item.kecamatanName, item.id)
          ),
        }));
      }
    } catch (e) {
      console.log("errors", e);
    }
  };

  fetchDataKelurahan = async (id) => {
    try {
      const response = await Api.create("NAGAMAS_MASTER_DATA").getAllKelurahan(
        id
      );
      if (response.ok && response.data.data) {
        this.setState((prevValue) => ({
          ...prevValue,
          kelurahanOptions: response.data.data?.map((item) =>
            mapToObjectDDL(item.kelurahanname, item.id)
          ),
          zipCodeRaw: response.data.data,
        }));
      }
    } catch (e) {
      console.log("errors", e);
    }
  };

  handleReset = () => {
    this.setState((prevValue) => ({
      ...prevValue,
      filter: defaultFilter,
    }));
  };

  handleSubmit = () => {
    const { onSubmit } = this.props;
    onSubmit(this.state.filter);
  };

  setValue = (name, value) => {
    this.setState((prev) => ({
      ...prev,
      filter: {
        ...prev.filter,
        [name]: value,
      },
    }));
  };

  onDateChange = (key, name, value) => {
    if (
      R.equals(name, "tanggalAkhir") &&
      !R.isNil(this.state.filter[key]?.tanggalAwal) &&
      moment(value, "DD-MM-YYYY").isBefore(
        moment(this.state.filter[key].tanggalAwal, "DD-MM-YYYY")
      )
    ) {
      this.setState((prevValue) => ({
        ...prevValue,
        filter: {
          ...prevValue.filter,
          [key]: {
            tanggalAwal: moment(value).format("DD-MM-YYYY"),
            tanggalAkhir: moment(value).format("DD-MM-YYYY"),
          },
        },
      }));
      return;
    }

    this.setState((prevValue) => ({
      ...prevValue,
      filter: {
        ...prevValue.filter,
        [key]: {
          ...prevValue.filter[key],
          [name]: value,
        },
      },
    }));
  };

  render() {
    const { visible, onClickClose } = this.props;
    const {
      filter,
      provinceOptions,
      kabkotOptions,
      kecamatanOptions,
      kelurahanOptions,
      zipCodeOptions,
      levelOptions,
      loyaltyOptions,
      hobbyOptions,
      interestOptions,
    } = this.state;
    return (
      <React.Fragment>
        <SimpleModal
          title="Filter"
          visible={visible}
          onClickClose={() => onClickClose()}
          content={
            <ModalContainer>
              <SimpleInput
                name="kodeCabang"
                label="Kode Cabang"
                value={filter.kodeCabang}
                onChange={({ target }) =>
                  this.setValue(target.name, target.value)
                }
              />
              <div>
                <div className="txt-site txt-11 txt-main txt-bold">
                  <h4>Overdue</h4>
                </div>
                <FlexView style={{ alignItems: "center", gap: "20px" }}>
                  <SimpleDDL
                    box="search"
                    id="select_options_operator"
                    name="operator"
                    options={operatorOptions}
                    value={filter.operator}
                    containerclassname="width width-250px"
                    onChange={(value, { name }) => this.setValue(name, value)}
                  />
                  <SimpleInput
                    box="onlyNumber"
                    name="overdue"
                    value={filter.overdue}
                    onChange={({ target }) =>
                      this.setValue(target.name, target.value)
                    }
                  />
                  <div className="txt-site txt-12 txt-main txt-bold margin-bottom-20px">
                    <h4>Days</h4>
                  </div>
                </FlexView>
              </div>
              <DateRange
                data={filter.tanggalProspek}
                label="Tanggal Prospek"
                startDateName="tanggalAwal"
                endDateName="tanggalAkhir"
                onStartDateChange={(name, value) =>
                  this.onDateChange(
                    "tanggalProspek",
                    name,
                    moment(value).format("DD-MM-YYYY")
                  )
                }
                onEndDateChange={(name, value) =>
                  this.onDateChange(
                    "tanggalProspek",
                    name,
                    moment(value).format("DD-MM-YYYY")
                  )
                }
              />
              <SimpleInput
                name="prospectName"
                label="Nomor Prospek"
                value={filter.prospectName}
                onChange={({ target }) =>
                  this.setValue(target.name, target.value)
                }
              />
              <SimpleDDL
                id="select_options_prospek_category"
                box="search"
                name="prospectCategory"
                label="Kategori Prospek"
                options={prospekCategoryOptions}
                value={filter.prospectCategory}
                onChange={(value, { name }) => this.setValue(name, value)}
              />
              <SimpleDDL
                id="select_options_prospek_type"
                box="search"
                name="prospectKind"
                label="Jenis Prospek"
                options={prospekTypeOptions}
                value={filter.prospectKind}
                onChange={(value, { name }) => this.setValue(name, value)}
              />
              <SimpleDDL
                id="select_options_prospek_source"
                box="search"
                name="prospectSource"
                label="Asal Prospek"
                options={prospekSourceOptions}
                value={filter.prospectSource}
                onChange={(value, { name }) => this.setValue(name, value)}
              />
              <SimpleInput
                name="sourceCabang"
                label="Cabang Asal"
                value={filter.sourceCabang}
                onChange={({ target }) =>
                  this.setValue(target.name, target.value)
                }
              />
              <SimpleInput
                name="ownerProspect"
                label="Pemilik Prospek"
                value={filter.ownerProspect}
                onChange={({ target }) =>
                  this.setValue(target.name, target.value)
                }
              />
              <SimpleInput
                name="lastSeller"
                label="Penjual Terakhir"
                value={filter.lastSeller}
                onChange={({ target }) =>
                  this.setValue(target.name, target.value)
                }
              />
              <DateRange
                data={filter.fuDate}
                label="Last Follow Up Date"
                startDateName="tanggalAwal"
                endDateName="tanggalAkhir"
                onStartDateChange={(name, value) =>
                  this.onDateChange(
                    "fuDate",
                    name,
                    moment(value).format("DD-MM-YYYY")
                  )
                }
                onEndDateChange={(name, value) =>
                  this.onDateChange(
                    "fuDate",
                    name,
                    moment(value).format("DD-MM-YYYY")
                  )
                }
              />
              <SimpleInput
                name="lastFollowUpStatus"
                label="Last Follow Up Status"
                value={filter.lastFollowUpStatus}
                onChange={({ target }) =>
                  this.setValue(target.name, target.value)
                }
              />
              <SimpleInput
                name="lastFollowUpBy"
                label="Last Follow Up By"
                value={filter.lastFollowUpBy}
                onChange={({ target }) =>
                  this.setValue(target.name, target.value)
                }
              />
              <DateRange
                data={filter.appointmentDate}
                label="Next Appointment Date"
                startDateName="tanggalAwal"
                endDateName="tanggalAkhir"
                onStartDateChange={(name, value) =>
                  this.onDateChange(
                    "appointmentDate",
                    name,
                    moment(value).format("DD-MM-YYYY")
                  )
                }
                onEndDateChange={(name, value) =>
                  this.onDateChange(
                    "appointmentDate",
                    name,
                    moment(value).format("DD-MM-YYYY")
                  )
                }
              />
              <SimpleInput
                name="information"
                label="Keterangan"
                value={filter.information}
                onChange={({ target }) =>
                  this.setValue(target.name, target.value)
                }
              />
              <SimpleInput
                name="nama"
                label="Nama"
                value={filter.nama}
                onChange={({ target }) =>
                  this.setValue(target.name, target.value)
                }
              />
              <SimpleInput
                name="nik"
                label="NIK"
                value={filter.nik}
                onChange={({ target }) =>
                  this.setValue(target.name, target.value)
                }
              />
              <SimpleInput
                name="handPhoneNumber"
                label="No HP"
                value={filter.handPhoneNumber}
                onChange={({ target }) =>
                  this.setValue(target.name, target.value)
                }
              />
              <SimpleInput
                name="alamat"
                label="Alamat"
                value={filter.alamat}
                onChange={({ target }) =>
                  this.setValue(target.name, target.value)
                }
              />
              <SimpleDDL
                id="select_options_province"
                box="search"
                name="province"
                label="Provinsi"
                options={provinceOptions}
                value={filter.province}
                onChange={(value, { name }) => this.setValue(name, value)}
              />
              <SimpleDDL
                id="select_options_kabkot"
                box="search"
                name="kabkot"
                label="Kota/Kabupaten"
                options={kabkotOptions}
                value={filter.kabkot}
                onChange={(value, { name }) => this.setValue(name, value)}
              />
              <SimpleDDL
                id="select_options_kecamatan"
                box="search"
                name="kecamatan"
                label="Kecamatan"
                options={kecamatanOptions}
                value={filter.kecamatan}
                onChange={(value, { name }) => this.setValue(name, value)}
              />
              <SimpleDDL
                id="select_options_kelurahan"
                box="search"
                name="kelurahan"
                label="Kelurahan"
                options={kelurahanOptions}
                value={filter.kelurahan}
                onChange={(value, { name }) => this.setValue(name, value)}
              />
              <SimpleDDL
                id="select_options_zip_code"
                box="search"
                name="kodePos"
                label="Kode Pos"
                options={zipCodeOptions}
                value={filter?.kodePos}
                onChange={(value, { name }) => this.setValue(name, value)}
              />
              <SimpleInput
                name="memberId"
                label="Member ID"
                value={filter.memberId}
                onChange={({ target }) =>
                  this.setValue(target.name, target.value)
                }
              />
              <SimpleDDL
                id="select_options_member_level"
                box="search"
                name="memberLevel"
                label="Member Level"
                options={levelOptions}
                value={filter.memberLevel}
                onChange={(value, { name }) => this.setValue(name, value)}
              />
              <SimpleDDL
                id="select_options_loyalty_level"
                box="search"
                name="loyaltyLevel"
                label="Loyalty Level"
                options={loyaltyOptions}
                value={filter.loyaltyLevel}
                onChange={(value, { name }) => this.setValue(name, value)}
              />
              <SimpleDDL
                id="select_options_facebook"
                box="search"
                name="facebook"
                label="Facebook"
                options={socMedOptions}
                value={filter.facebook}
                onChange={(value, { name }) => this.setValue(name, value)}
              />
              <SimpleDDL
                id="select_options_instagram"
                box="search"
                name="instagram"
                label="Instagram"
                options={socMedOptions}
                value={filter.instagram}
                onChange={(value, { name }) => this.setValue(name, value)}
              />
              <SimpleDDL
                id="select_options_linkedin"
                box="search"
                name="linkedin"
                label="LinkedIn"
                options={socMedOptions}
                value={filter.linkedin}
                onChange={(value, { name }) => this.setValue(name, value)}
              />
              <SimpleDDL
                id="select_options_twitter"
                box="search"
                name="x"
                label="X (Twitter)"
                options={socMedOptions}
                value={filter.x}
                onChange={(value, { name }) => this.setValue(name, value)}
              />
              <SimpleDDL
                id="select_options_tiktok"
                box="search"
                name="tiktok"
                label="TikTok"
                options={socMedOptions}
                value={filter.tiktok}
                onChange={(value, { name }) => this.setValue(name, value)}
              />
              <SimpleDDL
                id="select_options_hobby"
                box="multiselect"
                name="hobby"
                label="Hobby"
                options={hobbyOptions}
                value={filter.hobby}
                onChange={(value, { name }) => this.setValue(name, value)}
              />
              <SimpleDDL
                id="select_options_interest"
                box="multiselect"
                name="interest"
                label="Interest"
                options={interestOptions}
                value={filter.interest}
                onChange={(value, { name }) => this.setValue(name, value)}
              />
              <FlexView
                style={{
                  justifyContent: "center",
                  marginTop: "20px",
                  gap: "20px",
                }}
              >
                <SimpleButton onClick={this.handleReset}>Reset</SimpleButton>
                <SimpleButton onClick={this.handleSubmit}>
                  Terapkan
                </SimpleButton>
              </FlexView>
            </ModalContainer>
          }
        />
      </React.Fragment>
    );
  }
}
